import { CircularProgress, Modal } from "@mui/material";
import { ButtonRow, ModalWrapper, StyledBackdrop, StyledButton } from "./Styled";
import InfoIcon from "../../svg/InfoIcon";

interface ConfirmModalProps {
    open: boolean;
    handleClose: Function;
    handleConfirm: Function;
    children: React.ReactNode;
    confirmButtonText: string;
    isLoading?: boolean;
}

export const ConfirmModal = ({
                                 open,
                                 handleClose,
                                 handleConfirm,
                                 children,
                                 confirmButtonText,
                                 isLoading = false,
                             }: ConfirmModalProps) => {
    return (
        <Modal
            open={open}
            onClose={() => handleClose()}
            closeAfterTransition
            BackdropComponent={StyledBackdrop}
            BackdropProps={{
                timeout: 500,
                onClick: (e) => e.stopPropagation(),
            }}
        >
            <ModalWrapper
                isOpen={open}
                className="tw-w-[100px] tw-min-h-fit tw-gap-6 tw-flex tw-justify-center tw-items-center"
            >
                <InfoIcon />

                {children}

                <ButtonRow>
                    <StyledButton onClick={() => handleClose()}>
                        Huỷ bỏ
                    </StyledButton>
                    <StyledButton
                        variant="contained"
                        onClick={() => handleConfirm()}
                        disabled={isLoading}
                    >
                        {isLoading && <CircularProgress size={16} style={{ marginRight: 8 }} />}
                        {confirmButtonText}
                    </StyledButton>
                </ButtonRow>
            </ModalWrapper>
        </Modal>
    );
};
